import React, { Component } from "react";
import { ScrollView, View } from "react-native";
import { Button, Text, } from "native-base";
import Dialog from "./Dialog";
import { AppStyles } from "../../theme";
import { withTranslation } from "react-i18next";
import UIDs from "../../UIDs";
import _ from "lodash";

const uid = UIDs.components.ui.commonmodal;

/**
 * Right now, we mostly are using alert to pop a message,
 * but sometimes we need display complexed view ,
 * in this case we might use current component
 *
 * Need to do: We may need to enhance style of dialog to ensure it is a modern dialog
 *
 * How to use
 * 1. dim modal somewhere
 * <CommonModal ref={(ref) => this.localVars.commonModalRef = ref} />
 * 2. call show method with options
        var options = {
                        showCancelButton: true,
                        body: <Text ellipsizeMode="tail" numberOfLines={1}>
                                    123456
                                </Text>
                    };

                    Or
                    var options = {
                        body: <AutoHeightWebView
                            maxHeight={480}
                            source={{ html: canSendJoinRequest.message }}
                            style={[AppStyles.alignSelfstretch, { width: null }]}
                            scalesPageToFit={true}
                            automaticallyAdjustContentInsets={true}
                        />
                    };

        this.localVars.commonModalRef.show(options);
 *
 */
class CommonModal extends Component {
    localVars = {
        options: {
            body: null,
            showConfirmButton: false,
            showCancelButton: false,
            confirmButtonText: this.props.t("ok"),
            onConfirmButtonPress: null,
            cancelButtonText: this.props.t("cancel"),
            onCancelButtonPress: null,
            showModalHeader: false,
            showCloseButton: true,
            headerSubject: "",
            tapOutsideCloseCallBack: null,
        },
    };
    constructor(props) {
        super(props);
        this.state = {
            modalVisible: false,
        };
    }

    componentDidMount() {
        const { childRef } = this.props;
        childRef(this);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.visible && nextProps.visible !== this.state.modalVisible) {
            this.setState({ modalVisible: nextProps.visible });
        }
    }

    componentWillUnmount() {
        this.hide();

        const { childRef } = this.props;
        childRef(undefined);
    }

    show(options) {
        var nextState = { ...this.state, ...{ modalVisible: true, } };

        this.localVars.options = { ...this.localVars.options, ...options };
        this.setState(nextState);
    }

    hide() {
        this.setState({
            modalVisible: false
        });
    }

    render() {
        return (
            <Dialog
                animationType={"fade"}
                transparent={true}
                ref={ref => (this.dialog = ref)}
                visible={this.state.modalVisible}
                closeWhenTapOutside={true}
                style={{ backgroundColor: "rgba(3,3,3,0.5)" }}
                tapOutsideCloseCallBack={() => {
                    _.isFunction(this.localVars.options.tapOutsideCloseCallBack) && this.localVars.options.tapOutsideCloseCallBack()
                }}
            >
                {this.localVars.options.showModalHeader && this.localVars.options.headerSubject !== "" ?
                    <Dialog.Header showCloseButton={this.localVars.options.showCloseButton} key="modalHeader">
                        <Text ellipsizeMode="tail" numberOfLines={1}> {this.localVars.options.headerSubject}</Text>
                    </Dialog.Header>
                    : null}
                <Dialog.Body>
                    <ScrollView
                        style={{ maxHeight: (AppStyles.windowSize.height - 50) * 0.7 }}>
                        {this.localVars.options.body}
                    </ScrollView>
                </Dialog.Body>
                <Dialog.Footer>
                    {!this.localVars.options.showConfirmButton ? null :
                        <View style={AppStyles.flex1}>
                            <Button primary full style={{ borderBottomLeftRadius: 2, height: 36 }} onPress={this.onConfirmPressed}>
                                <Text ellipsizeMode="tail" numberOfLines={1} uppercase={false}>
                                    {this.localVars.options.confirmButtonText}
                                </Text>
                            </Button>
                        </View>
                    }
                    {!this.localVars.options.showCancelButton ? null :
                        <View style={AppStyles.flex1}>
                            <Button light full style={{ borderBottomLeftRadius: 2, height: 36 }} onPress={this.onCancelPressed}>
                                <Text ellipsizeMode="tail" numberOfLines={1} uppercase={false}>
                                    {this.localVars.options.cancelButtonText}
                                </Text>
                            </Button>
                        </View>
                    }
                </Dialog.Footer>
            </Dialog >
        );
    }

    onCancelPressed = () => {
        if (this.dialog) {
            if (this.localVars.options.onCancelButtonPress) {
                this.localVars.options.onCancelButtonPress();
            } else {
                this.dialog.hide();
            }
        }
    };

    onConfirmPressed = () => {
        if (this.dialog) {
            if (this.localVars.options.onConfirmButtonPress) {
                this.localVars.options.onConfirmButtonPress();
            } else {
                this.dialog.hide();
            }
        }
    };

}

export default withTranslation(uid)(CommonModal);
